<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="63" height="144" viewBox="0 0 63 144" fill="none">
    <path d="M63 1L1 1L1 144" stroke="white" />
  </svg>
</template>
